import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import ApiOutlined from '@ant-design/icons/ApiOutlined';
import KeyOutlined from '@ant-design/icons/KeyOutlined';
import SendOutlined from '@ant-design/icons/SendOutlined';
import LinkedinOutlined from '@ant-design/icons/LinkedinOutlined';

const admin = {
  id: 'group-admin',
  title: 'Administração',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'jobs',
      title: 'Jobs (background)',
      type: 'item',
      url: '/admin/jobs',
      icon: ScheduleOutlined,
      breadcrumbs: false
    },
    {
      id: 'usuarios-online',
      title: 'Usuários online',
      type: 'item',
      url: '/admin/usuarios-online',
      icon: TeamOutlined,
      permissions: ['admin.usuarios.view'],
      breadcrumbs: false
    },
    {
      id: 'integracoes',
      title: 'Integrações',
      type: 'item',
      url: '/admin/integracoes',
      icon: ApiOutlined,
      permissions: ['admin.integracoes.manage'],
      breadcrumbs: false
    },
    {
      // O conector do LinkedIn (F3): contas conectadas, pausar/retomar e "Desligar tudo". Fica ao
      // lado de Integrações porque é a mesma pergunta ("o que está ligado na casa"), mas a alçada é
      // do CRM (`crm.linkedin.ver_todas`) — quem gere vendas não precisa administrar integrações.
      id: 'integracoes-linkedin',
      title: 'LinkedIn',
      type: 'item',
      url: '/admin/integracoes/linkedin',
      icon: LinkedinOutlined,
      permissions: ['crm.linkedin.ver_todas'],
      breadcrumbs: false
    },
    {
      id: 'contas-servico',
      title: 'Contas de serviço',
      type: 'item',
      url: '/admin/servicos',
      icon: KeyOutlined,
      permissions: ['auth.servicos.manage'],
      breadcrumbs: false
    },
    {
      // Era "CRM → Configuração → Webhooks de saída". Subiu para cá com o motor: o catálogo de
      // eventos assináveis é de toda a casa (CRM, Helpdesk, …), e uma tela dentro de um módulo
      // convidaria a cadastrar a assinatura do Helpdesk em "Configuração do CRM".
      id: 'webhooks-saida',
      title: 'Webhooks de saída',
      type: 'item',
      url: '/admin/webhooks',
      icon: SendOutlined,
      permissions: ['admin.webhooks.manage'],
      breadcrumbs: false
    }
  ]
};

export default admin;
